export const verificationRequests = {
  appBarTitle: "Verification Requests",
  totalRequests: "Total Requests",
  table: {
    requestNumber: "Request number",
    driverName: "Driver Name",
    driverNumber: "Driver Number",
    ownerName: "Owner Name",
    status: "Status",
    numberOfTrips: "Number of Trips",
    joiningDate: "Joining Date",
    requestDate: "Request Date",
    decisionDate: "Decision Date",
    viewRejectionReason: "View rejection reason",
    rejectionReason: "Rejection Reason",
  },
  filters: {
    joiningDate: "Joining Date",
    requestDate: "Request Date",
    teamName: "Team Name",
    driverName: "Driver Name",
    numberOfTrips: "Number of Trips",
    decisionDate: "Decision Date",
    status: "Status",
  },
  status: {
    pending: "Pending",
    rejected: "Rejected",
    accepted: "Accepted",
  },
};
